/**
 * Pathriva Chart Theme — dark mode, clinical data visualization
 */

export const COLORS = {
  primary: "#00e5ff",
  secondary: "#7c3aed",
  success: "#34d399",
  warning: "#fbbf24",
  danger: "#ff4d6d",
  info: "#60a5fa",
  muted: "#4a6175",
  text: "#e6edf3",
  textDim: "#8b949e",
  bg: "#131920",
  bgDark: "#060810",
  border: "#1e2d3d",
  gridLine: "rgba(255,255,255,0.06)",
};

export const CHART_COLORS = [
  "#00e5ff", "#7c3aed", "#34d399", "#fbbf24", "#ff4d6d",
  "#60a5fa", "#f472b6", "#a78bfa", "#fb923c", "#2dd4bf",
];

export const RISK_COLORS = {
  high: "#ff4d6d",
  medium: "#fbbf24",
  low: "#34d399",
};

export const PROGRAM_COLORS = {
  "Semaglutide 2.4mg": "#00e5ff",
  "Tirzepatide 15mg": "#7c3aed",
  "Liraglutide 3.0mg": "#34d399",
  "Semaglutide 1.0mg": "#60a5fa",
};

export const commonAxisStyle = {
  fontSize: 10,
  fill: COLORS.muted,
  fontFamily: "'Inter', -apple-system, sans-serif",
};

export const commonGridStyle = {
  strokeDasharray: "3 3",
  stroke: COLORS.gridLine,
};

export const tooltipStyle = {
  contentStyle: {
    background: "#1a2332",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    fontSize: 11,
    color: COLORS.text,
    padding: "8px 12px",
  },
  itemStyle: { fontSize: 11, color: COLORS.text },
  labelStyle: { fontSize: 10, color: COLORS.muted, marginBottom: 4 },
};

export const cardStyle = {
  background: COLORS.bg,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 10,
  padding: 20,
};

export const chartHeaderStyle = {
  fontSize: 13,
  fontWeight: 700,
  color: COLORS.text,
  marginBottom: 16,
};
